import { useScopedPathname } from "@-/com.npmjs.expo-router";
import { useContextSelector } from "@-/com.npmjs.use-context-selectors";
import { LearnMapModeContext, type LearnMapMode } from "#learn-map-mode-context";

/**
 * One field (or a value derived from them) of Learn's mode, re-rendering only when it changes.
 * `undefined` outside `LearnLayout` (a surface rendered on its own in a test).
 */
export function useLearnMapModeSelector<T>(select: (mode: LearnMapMode) => T): T | undefined {
  return useContextSelector(LearnMapModeContext, (mode) =>
    mode === null ? undefined : select(mode),
  );
}

/**
 * `useScopedPathname("/learn")` for the cards: while a map route is open it stays on the route the
 * cards showed, so the deck and the summary keep their place beneath the map.
 */
export function useLearnCardsPathname(): string {
  const pathname = useScopedPathname("/learn");
  return useLearnMapModeSelector((mode) => mode.cardsPathname) ?? pathname;
}

/** Whether a map route is Learn's route; the cards are then away and inactive. */
export function useIsLearnMapOpen(): boolean {
  return useLearnMapModeSelector((mode) => mode.isMapOpen) ?? false;
}
